import { Box, HStack, Center } from "@chakra-ui/react";
import Avatar from "components/Avatar";
import BoldSpinner from "components/BoldSpinner";
import FancyBearImage from "components/FancyBearImage";
import TokenSelect from "components/TokenSelect";
import useAssets from "hooks/useAssets";
import useBear from "hooks/useBear";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

type BearSelectorContainerProps = {
  basePath: string;
};

const BearSelectorContainer = ({ basePath }: BearSelectorContainerProps) => {
  const { fancyBearsInWallet } = useAssets();
  const { tokenId, isLoading } = useBear();

  const navigate = useNavigate();

  const handleChange = useCallback(
    (tokenId?: number) => {
      if (tokenId) {
        navigate(`${basePath}/${tokenId}`);
      }
    },
    [basePath, navigate]
  );

  return tokenId ? (
    <HStack spacing="3">
      <Avatar size="16" position="relative">
        <FancyBearImage
          tokenId={tokenId}
          objectFit="cover"
          opacity={isLoading ? 0.5 : 1}
          transition="all 0.15s"
        />

        {isLoading && (
          <Center
            position="absolute"
            w="full"
            h="full"
            zIndex="1"
            top="0"
            left="0"
          >
            <BoldSpinner size="md" thickness="3px" />
          </Center>
        )}
      </Avatar>

      <Box
        w={{
          base: "9rem",
          sm: "10rem",
        }}
      >
        <TokenSelect
          tokenId={tokenId}
          ownedTokens={fancyBearsInWallet}
          onChange={handleChange}
          chakraStyles={{
            control: (provided) => ({
              ...provided,
              fontWeight: "bold",
              border: "none",
              fontSize: {
                base: "2xl",
                sm: "3xl",
              },
              p: "0",
              lineHeight: "1",
              borderBottom: "2px solid",
            }),
            valueContainer: (provided) => ({
              ...provided,
              p: "0",
            }),
            dropdownIndicator: (provided) => ({
              ...provided,
              px: "0",
              bg: "transparent",
            }),
            downChevron: (provided) => ({
              ...provided,
              width: "9",
              height: "auto",
            }),
          }}
        />
      </Box>
    </HStack>
  ) : null;
};

export default BearSelectorContainer;
